import { paymentReceiptsService } from '@/services';
import { downloadBlob } from '@/shared/utils/download-blob.util';
import { useMutation } from '@tanstack/react-query';

/** Baixa o comprovante em PDF da parcela do token. */
export function usePaymentReceiptPdf(token: string) {
  return useMutation({
    retry: false,
    mutationFn: async () => {
      const { blob, filename } =
        await paymentReceiptsService.getReceiptPdf(token);
      downloadBlob(blob, filename);
    },
  });
}
